import { EnvType } from '@shared-types';
import { EasyKalaEnvironment } from './environment.model';
import { getKalaOidcSettings } from './environment.default';
import { envDefault } from '@shared';

export const environment: EasyKalaEnvironment = {
	...envDefault,
	setting: {
		sseApiPath: 'https://kala-sse.easytrader.ir/',
		kalaApiPath: 'https://kala-api.easytrader.ir/api/v1',
		walletApiPath: 'https://kala-api.easytrader.ir/wallet/api/v1',
		chartApiPath: 'https://kala-api.easytrader.ir/marketdata/api/v1/chart',
		marketDataApiPath: 'https://kala-api.easytrader.ir/marketdata/api/v1'
	},
	chatBot: {
		url: 'https://chatbot.emofid.com/livechat',
		isActive: true
	},
	oidcSettings: {
		...getKalaOidcSettings({ env: EnvType.PROD, spaAppUrl: envDefault.appUrl })
	}
};
